<template>
  <ul class="mobile-ul" v-if="isShow">
    <li class="mobile-li" v-for="(item,i) in menuData" :key="i">
      <a href="javascript:;" @click="handleJump(item)" class="mobile-a">
        {{item.name}} <a-icon type="down" v-if="item.children" />
      </a>
      <ul :class="['mobile-sub-ul', {'border-top': item.isExpand}]" v-if="item.children && item.isExpand">
        <li class="mobile-sub-li" v-for="(subMenu,j) in item.children" :key="j">
          <a href="javascript:;" @click="handleJump(subMenu)" class="mobile-sub-a">{{subMenu.name}} <a-icon type="down" v-if="subMenu.children" /></a>
          <ul class="mobile-sub-ul" v-if="subMenu.children && subMenu.isExpand">
            <li class="mobile-sub-li" v-for="(menu,z) in subMenu.children" :key="z">
              <a href="javascript:;" @click="handleJump(menu)" class="mobile-sub-a">
                {{menu.name}}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  data () {
    return {
      isShow: false,
      menuData: [{
        name: this.$root.language.products,
        path: '/products',
        isExpand: false,
        children: [{
          name: this.$root.language.platform,
          path: '/products/platform',
          group: true,
          isExpand: false,
          children: [{
            name: this.$root.language.jicCloud,
            isAnchor: true,
            path: '/products/industryCloud'
          },
          {
            name: this.$root.language.devopsCloud,
            isAnchor: true,
            path: '/products/cloudPlatform'
          }
          ]
        },
        {
          name: this.$root.language.engineering,
          path: '/products/engineering',
          group: true,
          isExpand: false,
          children: [{
            name: this.$root.language.navigator,
            isAnchor: true,
            path: '/products/navigator'
          },
          {
            name: this.$root.language.pdm,
            isAnchor: true,
            path: '/products/pdm'
          },
          {
            name: this.$root.language.ppm,
            isAnchor: true,
            path: '/products/ppm'
          },
          {
            name: this.$root.language.mpm,
            isAnchor: true,
            path: '/products/mpm'
          },
          {
            name: this.$root.language.npi,
            isAnchor: true,
            path: '/products/npi'
          }
          ]
        },
        {
          name: this.$root.language.factory,
          path: '/products/factory',
          group: true,
          isExpand: false,
          children: [{
            name: this.$root.language.pqm,
            isAnchor: true,
            path: '/products/pqm'
          },
          {
            name: this.$root.language.deviceMate,
            isAnchor: true,
            path: '/products/deviceMate'
          },
          {
            name: this.$root.language.productionLineEngine,
            isAnchor: true,
            path: '/products/productionLine'
          }
          ]
        }
        ]
      },
      {
        name: this.$root.language.solutions,
        path: '/solutions'
      },
      {
        name: this.$root.language.technology,
        path: '/technology'
      },
      {
        name: this.$root.language.company,
        path: '/company',
        group: true,
        isExpand: false,
        children: [{
          name: this.$root.language.whyJwi,
          path: '/company/why'
        },
        {
          name: this.$root.language.history,
          path: '/company/history'
        },
        {
          name: this.$root.language.careers,
          path: '/company/careers'
        }
        ]
      }
      ]
    }
  },
  methods: {
    open () {
      this.isShow = true
    },
    close () {
      function setExpand (data) {
        data.forEach(item => {
          if (item.children) {
            item.isExpand = false
            setExpand(item.children)
          }
        })
      }

      setExpand(this.menuData)
      this.isShow = false
    },
    handleJump (item) {
      // 判断是否分组标题，分组不跳转
      if (item.children) {
        item.isExpand = !item.isExpand
      } else {
        if (item.path && !item.group && !item.isAnchor) {
          this.$router.push({
            path: item.path
          })
        } else if (item.isAnchor) {
          this.$router.push({
            path: '/products'
          })
          this.$EventBus.$emit('selectNavigation', item)
        }
        this.close()
      }
    }
  }
}

</script>

<style scoped>
  .mobile-ul {
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 99;
    background: #eee;
    width: 100%;
    margin: 0;
  }

  .mobile-li {
    border-bottom: 1px solid #fff;
  }

  .mobile-a {
    display: inline-block;
    padding: 10px;
    color: #2E3635;
  }

  .mobile-sub-ul {
    padding-left: 20px;
  }
  .mobile-sub-a {
    display: inline-block;
    padding: 5px 10px;
    color: #2E3635;
  }

  .border-top {
    border-top: 1px solid #fff;
  }
</style>
